import swal from "sweetalert";

/**
 * Thin wrapper around sweetalert to give us a lightweight toast-ish API.
 * We keep the surface tiny — success / error — so we can swap the underlying
 * library later without touching call sites.
 *
 * NOTE: `title` intentionally left blank on both variants; sweetalert renders
 * a clean text-only toast and the calling code passes a localized message.
 */
export const toast = {
  success: (message) =>
    swal({ title: "", text: message, icon: "success", timer: 2000, buttons: false }),
  error: (message) =>
    swal({ title: "", text: message, icon: "error" }),
};

export default toast;
